import * as React from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../../redux';
import {change, getFormValues} from 'redux-form';
import View from './view';
import {Forms} from '../../../../../shared/models/forms';
import {getProductsFilterName} from '../../pipes';
import {ProductsAcceptorFilterForm, PropsProductAcceptorList} from '../../model';

export const ProductAcceptorFilterList: React.FC<PropsProductAcceptorList> = (props) => {
  const filterProductsAcceptorFormValues = useSelector(
    getFormValues(Forms.productsAcceptorFilterForm),
  ) as ProductsAcceptorFilterForm;
  const prevProductsAcceptorFilterFormValues = React.useRef<boolean[]>(
    filterProductsAcceptorFormValues?.productAcceptor ?? [],
  );
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    if (!filterProductsAcceptorFormValues?.productAcceptor) {
      dispatch(change(Forms.productsAcceptorFilterForm, getProductsFilterName(String(0), 'productAcceptor'), true));
      prevProductsAcceptorFilterFormValues.current = [true];
    } else {
      const isAnySelected = filterProductsAcceptorFormValues.productAcceptor.some((item, index) =>
        index ? item : false,
      );
      if (!prevProductsAcceptorFilterFormValues.current[0] && filterProductsAcceptorFormValues.productAcceptor[0]) {
        if (isAnySelected) dispatch(change(Forms.productsAcceptorFilterForm, 'productAcceptor', [true]));
      } else {
        if (isAnySelected) {
          if (filterProductsAcceptorFormValues.productAcceptor[0])
            dispatch(
              change(Forms.productsAcceptorFilterForm, getProductsFilterName(String(0), 'productAcceptor'), false),
            );
        } else {
          if (!filterProductsAcceptorFormValues.productAcceptor[0])
            dispatch(
              change(Forms.productsAcceptorFilterForm, getProductsFilterName(String(0), 'productAcceptor'), true),
            );
        }
      }
      prevProductsAcceptorFilterFormValues.current = filterProductsAcceptorFormValues.productAcceptor;
    }
  }, [filterProductsAcceptorFormValues]);
  return <View {...props} />;
};
